module.exports = ".file-chooser {\r\n    cursor: pointer;\r\n    max-width: 120px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/theme-settings/theme-settings.component.css
// module id = 620
// module chunks = 1